import type { ReactNode } from "react";
import ReactDOMServer from "react-dom/server";
import SVGWrapper from "./svgWrapper";

export function jsxToString(el: ReactNode, wrapSvg = false): string {
  const jsxEl = wrapSvg ? <SVGWrapper>{el}</SVGWrapper> : el;

  return ReactDOMServer.renderToStaticMarkup(jsxEl);
}
